import { inject, Injectable } from '@angular/core';

import { FormContext } from '@blaze-shared/elements-domain';
import { sentryLog } from '@blaze-shared/logger-util';
import { PageContext } from '@blaze-shared/projects-domain';
import { DatasetRow } from '@blaze-shared/schema-domain';

import { createPageContextSchema, PageContextSourceSchema } from '../create-page-context-schema';
import { preparePageContextData } from '../prepare-data';
import { SchemaDataValidator } from '../schema-data-validator';
export interface PageContextSourceData {
  data: DatasetRow;
  formContext: FormContext | undefined;
  isEmptyishRow: boolean;
  pageId: string;
  schema: PageContextSourceSchema;
}

@Injectable({
  providedIn: 'root',
})
export class PreparePageContextDataService {
  private readonly schemaDataValidator = inject(SchemaDataValidator);

  preparePageContext(pageContextSourceData: PageContextSourceData): PageContext {
    const { data, schema, pageId } = pageContextSourceData;

    // Validate data vs schema
    // For now - just validate, don't throw an error
    if (!this.schemaDataValidator.validateData(schema, data)) {
      sentryLog(`Validation issue`, 'warning', {
        jsonPayload: { pageId, schema, data },
      });
    }

    return this.generatePageContext(pageContextSourceData);
  }

  /**
   * This creates the PageContext object including the data and the schema.
   */
  private generatePageContext({
    data,
    schema,
    pageId,
    formContext,
    isEmptyishRow,
  }: PageContextSourceData): PageContext {
    const pageContextId = crypto.randomUUID();
    const pageContextSchema = createPageContextSchema(schema, pageId, pageContextId);

    const dataRowIdColumnName = schema.columns.find((column) => column.isId)?.name;
    const pageDataRowId = dataRowIdColumnName ? data[dataRowIdColumnName] : undefined;

    return {
      id: pageContextId,
      pageId,
      data: preparePageContextData(data),
      schema: pageContextSchema,
      formContext,
      modifiedTime: Date.now(),
      pageDataRowId,
      isEmptyishRow,
    };
  }
}
